module.exports = __webpack_public_path__ + "logo_guco_transp.png?ab203bccf0719c9fa15511a3da279be1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_guco_transp.png
// module id = 97
// module chunks = 0